import RedeemSucessPage from './RedeemSucessPage';
export default RedeemSucessPage;
